var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10C2.55228 10 3 10.4477 3 11V13H13V11C13 10.4477 13.4477 10 14 10C14.5523 10 15 10.4477 15 11V14C15 14.5523 14.5523 15 14 15H2C1.44772 15 1 14.5523 1 14V11C1 10.4477 1.44772 10 2 10Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.29289 2.29289C4.68342 1.90237 5.31658 1.90237 5.70711 2.29289L8 4.58579L10.2929 2.29289C10.6834 1.90237 11.3166 1.90237 11.7071 2.29289C12.0976 2.68342 12.0976 3.31658 11.7071 3.70711L9.41421 6L11.7071 8.29289C12.0976 8.68342 12.0976 9.31658 11.7071 9.70711C11.3166 10.0976 10.6834 10.0976 10.2929 9.70711L8 7.41421L5.70711 9.70711C5.31658 10.0976 4.68342 10.0976 4.29289 9.70711C3.90237 9.31658 3.90237 8.68342 4.29289 8.29289L6.58579 6L4.29289 3.70711C3.90237 3.31658 3.90237 2.68342 4.29289 2.29289Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadRemove);
export default __webpack_public_path__ + "static/media/Download-Remove.8492c0e17bf8c9d7612821ac0397d1d7.svg";
export { ForwardRef as ReactComponent };